import request from '@/utils/request'

/** 获取当前文章的正文图片资源及服务端引用次数。 */
export function fetchArticleImages(articleId) {
    return request({
        url: `/FlowArticle/${articleId}/images`,
        method: 'get',
        loading: false
    })
}

/**
 * 上传一张正文图片。
 * @param {string} articleId 文章 ID 或当前用户的预留草稿 ID。
 * @param {File} file 待上传的图片文件。
 * @param {(progress: number) => void} onProgress 上传进度回调。
 */
export function uploadArticleImage(articleId, file, onProgress) {
    const data = new FormData()
    data.append('file', file)
    return request({
        url: `/FlowArticle/${articleId}/images`,
        method: 'post',
        data,
        headers: { 'Content-Type': 'multipart/form-data' },
        onUploadProgress: event => {
            if (!onProgress || !event.total) return
            onProgress(Math.round((event.loaded * 100) / event.total))
        },
        loading: false,
        suppressErrorMessage: true
    })
}

/** 修改资源显示名，物理地址及扩展名保持不变。 */
export function renameArticleImage(articleId, imageId, name) {
    return request({
        url: `/FlowArticle/${articleId}/images/${imageId}`,
        method: 'patch',
        data: { name },
        loading: false,
        suppressErrorMessage: true
    })
}

/** 删除未被已保存正文引用的图片资源。 */
export function deleteArticleImage(articleId, imageId) {
    return request({
        url: `/FlowArticle/${articleId}/images/${imageId}`,
        method: 'delete',
        loading: false,
        suppressErrorMessage: true
    })
}
